<template>
<div class="chapter">
<div class="inner_page">
<p class="toc-title"><span>Contents</span></p>
<p class="toc-text"><span><a href="#/xhtml/chapter001">1   The Hotel</a></span></p>
<p class="toc-text"><span><span href="#/xhtml/chapter002" title="Link target outside of Sample">2   Outside</span></span></p>
<p class="toc-text"><span><span href="#/xhtml/chapter003" title="Link target outside of Sample">3   Calvin and Buddy</span></span></p>
<p class="toc-text"><span><span href="#/xhtml/chapter004" title="Link target outside of Sample">4   Escaping Notice</span></span></p>
<p class="toc-text"><span><span href="#/xhtml/chapter005" title="Link target outside of Sample">5   The Coffee Van</span></span></p>
<p class="toc-text"><span><span href="#/xhtml/chapter006" title="Link target outside of Sample">6   Monkey Island</span></span></p>
<p class="toc-text"><span><span href="#/xhtml/chapter007" title="Link target outside of Sample">7   Out Cold</span></span></p>
<p class="toc-text"><span><span href="#/xhtml/chapter008" title="Link target outside of Sample">8   Oxygen</span></span></p>
<p class="toc-text"><span><span href="#/xhtml/chapter009" title="Link target outside of Sample">9   The Biddles</span></span></p>
<p class="toc-text1"><span><span href="#/xhtml/chapter010" title="Link target outside of Sample">10   Searching, Finding</span></span></p>
<p class="toc-text1"><span><span href="#/xhtml/author" title="Link target outside of Sample">About the Author</span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?0e9438dc